import React from "react";
import { Box, Grid } from "@material-ui/core";
import { CorrespondenceTable } from "../CorrespondenceTable";
import { CustomizedSearch } from "../../../custom/CustomizedSearch";
import AppAnimate from "../../../ui/AppAnimate/AppAnimate";
import { CustomizedWindow } from "../../../custom/CustomizedWindow";
import { SettledDetails } from "../../../document-managment/correspondence/SettledDetails";
import { ICorrespondence } from "../../../../interfaces/Correspondence";
import useReturned from "./useReturned";

interface ReturnedProps {
  correspondence: ICorrespondence[];
}

export const Returned = ({ correspondence }: ReturnedProps) => {
  const { intl, modalSeeOpen, date, onDeny, activeCorrespondence } =
    useReturned();

  return (
    <AppAnimate animation="transition.slideUpIn" delay={200}>
      <Box>
        <Box mb={3} fontSize={20}>
          <Grid container>
            <Grid item xs={7} />
            <Grid item xs={5}>
              <CustomizedSearch data={correspondence} />
            </Grid>
          </Grid>
        </Box>
        <CorrespondenceTable
          readOnly
          rows={correspondence}
          component="Returned"
        />
        <CustomizedWindow
          open={modalSeeOpen}
          content={<SettledDetails component="RETURNED" />}
          onDeny={onDeny}
          title={`${intl.formatMessage({ id: "Settled" })} No. ${
            activeCorrespondence?.id
          } -  ${date}`}
        />
      </Box>
    </AppAnimate>
  );
};
